import styled from '@emotion/styled'

import theme from 'styles/theme'

export const RelatedProjectsWrapper = styled.div`
  margin-top: 12px;
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 20px;

  @media (min-width: ${theme.token('breakpoints.lg')}) {
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;
    margin-left: 120px;
  }
`
